module.exports = __webpack_public_path__ + "static/media/expertise-header@3x.663156a0.jpg";